import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

export default function logEventWithPrefixAnalyticsUtil (prefix, eventName, properties) {
  if (prefix) {
    eventName = getActionStrReduxUtil(prefix, eventName)
  }
  return logEventAnalyticsUtil(eventName, properties)
}
